import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { IResearchPodcastPopulated } from '~global-interfaces/IResearchPodcast';

import { PodcastMiniPlayerComponent } from '~features/podcasts/podcast-mini-player/podcast-mini-player.component';
import { DateComponent } from '~shared/components/ui/date/date.component';

import { GlobalPodcastPlayerService } from '../global-podcast-player/global-podcast-player.service';

@Component({
  selector: 'app-podcast-list-item',
  imports: [PodcastMiniPlayerComponent, DateComponent, NgClass],
  templateUrl: './podcast-list-item.component.html',
})
export class PodcastListItemComponent {
  @Input() podcast: IResearchPodcastPopulated;
  @Input() showCloseButton = false;
  @Input() showImage = true;
  @Input() smallCompanyName = false;
  @Input() alternativeDatePoisition = false;
  @Input() hideLinkArrows = false;

  globalPodcastPlayerService = inject(GlobalPodcastPlayerService);
  close() {
    this.globalPodcastPlayerService.stopPodcast();
  }
}
